module.exports = __webpack_public_path__ + "static/media/large-engine-zoom.f45d7e55.png";